
export function convertBase64toBlob(content, contentType) {
    contentType = contentType || '';
    var sliceSize = 512;
    var byteCharacters = window.atob(content); //method which converts base64 to binary
    var byteArrays = [
    ];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, {
        type: contentType
    }); //statement which creates the blob
    return blob;
}

export function downloadPDF(pdf) {
    let blobURL = URL.createObjectURL(convertBase64toBlob(pdf, 'application/pdf'));
    let newWin = window.open(blobURL);
}

export function getObjections() {
    return JSON.parse(localStorage.getItem("objection"))
}

export function setObjections(objections) {
    return localStorage.setItem("objection", JSON.stringify(objections))
}

export function objectionNavigation(navigate) {
    let objections = getObjections()
    let otherObjection = objections.find(objection => !objection.isNavigationDone)
    if (otherObjection) {
        navigate(otherObjection.navigationPath)
    }
    else {
        navigate("/Review")
    }
}

export function getBlob(data) {
    let blob = convertBase64toBlob(data.split(",")[1], "application/pdf");
    return URL.createObjectURL(blob);
}

const digitToWord = {0: "Zero",1: "One",2: "Two",3: "Three",4: "Four",5: "Five",6: "Six",7: "Seven",8: "Eight",9: "Nine"};

export const convertFourDigitCodeToWord = (code) => {
    // Ensure the code is a string and has exactly 4 digits
    if (typeof code !== 'string' || code.length !== 4 || !/^\d{4}$/.test(code)) {
      return "Invalid input. Please enter a four-digit code.";
    }
    // Convert each digit to its corresponding word
    return Array.from(code)
      .map(digit => digitToWord[digit])
      .join(' '); // Join the words with a space
  };

  export  function insertHyphens(number) {
    const numberString = number.toString();
    const digitsArray = numberString.split('');
    const result = digitsArray.join('-');
    return result;
}
